import { Box, Button, Divider, Flex, Spacer, Text } from "@chakra-ui/react";
import React from "react";
import { useDashboardTitle } from "../../hooks/useDashboardTitle";

export const Title = ({ title, children = null }) => {
    useDashboardTitle(title);

    return (
        <Box marginBottom="20px">
            <Flex margin="10px 0 0 20px">
                <Text fontSize="xl">{ title }</Text>
                <Spacer />
                { children }
            </Flex>
            <Divider />
        </Box>
    );
};
